type AiExperienceState = {
	aiDecorationExperiencePluginState?: {
		isRunning?: boolean;
	};
	isShowingAcceptRejectScreen?: boolean;
	isStreaming?: boolean;
};

export const hasAiEditInProgressState = (state: AiExperienceState | undefined): boolean =>
	Boolean(
		state?.aiDecorationExperiencePluginState?.isRunning ||
		state?.isStreaming ||
		state?.isShowingAcceptRejectScreen,
	);
